module.exports = __webpack_public_path__ + "static/media/logo-heavy-inverse.fd92c4f9.png";